Object.defineProperty (module.exports, "__esModule", { value: true }),
module.exports.ObjectEncoding = module.exports.default = {
	AMF0: 0,
	AMF3: 3,
	HXSF: 10,
	JSON: 12,
	DEFAULT: 10
};